<section>
    <div class="wrapper">
      <article
        class="mrt-75"
        style="overflow: auto !important; min-height: calc(100vh - 117px)"
      >
        <h2 class="label">Pro-View Micro Services List</h2>
        <div class="table-container um-table-wrap" style="margin-bottom: 20px">
            <table mat-table [dataSource]="microservices" class="mat-table um-table">
                <ng-container matColumnDef="name">
                  <th class="left-sorted-header" mat-header-cell *matHeaderCellDef> Microservice </th>
                  <td class="left-sorted-header" mat-cell *matCellDef="let service"> {{service.name}} </td>
                </ng-container>
              
                <ng-container matColumnDef="status">
                  <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef> Status </th>
                  <td class="centered-sorted-header" mat-cell *matCellDef="let service">
                    <mat-icon *ngIf="service.status === 'healthy'" style="color: green;">check_circle</mat-icon>
                    <mat-icon *ngIf="service.status === 'unhealthy'" style="color: red;">cancel</mat-icon>
                  </td>
                </ng-container>
              
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
        </div>
        <!-- <app-event-timeline></app-event-timeline> -->
      </article>
    </div>
  </section>
  
